<template>
  <component
    :is="form ? 'form' : 'div'"
    class="outer-container transition-colors duration-1000 px-4 pb-4 card-shadow2"
    :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'"
    @submit="submit"
  >
    <header
      v-if="title"
      class="header-container flex justify-between items-center"
    >
      <p
        class="flex items-center py-3 font-bold"
        :class="[icon ? 'px-4' : 'px-6']"
      >
        <icon
          v-if="icon"
          :path="icon"
          class="mr-2 pb-1"
          :w="'w-5'"
          :h="'h-5'"
        />
        {{ title }}
      </p>
      <p
        v-if="Listinvoice"
        class="flex items-center py-3 flex-grow font-bold"
        :class="[icon ? 'px-4' : 'px-6']"
      >
        <check-radio-picker
          v-if="Listinvoice"
          v-model="filter.selectinv"
          @change="invselect()"
          :type="'select'"
          :options="{ 1: '' }"
          class="mr-3"
        >
        </check-radio-picker>
        {{ t("income.allinv") }}
        <!-- <check-radio-picker v-if="Listinvoice" class="pl-4 mr-3" type="radio" name="selectinv" v-model="filter.selectinv" @change="invselect()" :type="'select'" :options="{ false: 'Outstanding', true: 'All Invoice' }"></check-radio-picker> -->
      </p>

      <!-- <p v-if="Listoutstading" class="flex items-center py-3 flex-grow font-bold" :class="[ icon ? 'px-4' : 'px-6' ]">
                <jb-button label="Excel" color="info" class ="px-5 ml-3" small @click="ExcelData" />
                <jb-button label="PDF" color="info" class ="px-5 ml-3" small @click="PDFData" />
            </p> -->

      <p
        v-if="showApprove"
        class="flex items-center py-3 flex-grow font-bold"
        :class="[icon ? 'px-4' : 'px-6']"
      >
        <jb-button
          label="Approve"
          color="info"
          class="px-5 ml-3"
          small
          @click="approveAllData"
        />
        <jb-button
          label="Reject"
          color="danger"
          class="px-5 ml-3"
          small
          @click="rejectAllData"
        />
      </p>

      <div class="w-auto flex flex-nowrap gap-2">
        <jb-button
          v-if="closePayment"
          @click="closePaymentData"
          :label="t('Close')"
          color="info"
          :icon="mdiFileDocumentRemoveOutline"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="closePayment"
          @click="closePaymentData"
          color="info"
          :icon="mdiFileDocumentRemoveOutline"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="generatePayment"
          @click="generatePaymentData"
          :label="t('Allocation Payment')"
          color="info"
          :icon="mdiFileRefreshOutline"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="generatePayment"
          @click="generatePaymentData"
          color="info"
          :icon="mdiFileRefreshOutline"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="generateVA"
          @click="generateVAData"
          :label="t('Generate VA Number')"
          color="info"
          :icon="mdiFileRefreshOutline"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="generateVA"
          @click="generateVAData"
          color="info"
          :icon="mdiFileRefreshOutline"
          class="add-btn md:hidden"
        />

        <!-- Send to Approver -->
        <jb-button
          v-if="showSendApprove"
          @click="sendApproveData"
          :label="
            labelSendApproveButton ? labelSendApproveButton : 'Send to Approver'
          "
          color="info"
          :icon="mdiInvoiceSend"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="showSendApprove"
          @click="sendApproveData"
          color="info"
          :icon="mdiInvoiceSend"
          class="add-btn md:hidden"
        />

        <!-- Copy Syllabuss -->
        <jb-button
          v-if="showCopySyllabuss"
          @click="coptSyllabussData"
          :label="'Copy'"
          color="info"
          :icon="mdiContentCopy"
          class="add-btn hidden md:flex"
        />

        <!-- Copy Reject -->
        <jb-button
          v-if="showCopyReject"
          @click="coptRejectData"
          :label="'Copy Rejected Booking'"
          color="info"
          :icon="mdiContentCopy"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="showCopyReject"
          @click="coptRejectData"
          color="info"
          :icon="mdiContentCopy"
          class="add-btn md:hidden"
        />

        <!-- <jb-button v-if="pdfShow" label="PDF" color="info" class ="px-5 ml-3" small @click="pdfClick" /> -->

        <jb-button
          v-if="showCopyDocumentPsb && checkUser && hasCandidate"
          @click="copyDocumentPsb"
          :label="'Copy Document From PSB'"
          color="info"
          :icon="mdiDownloadCircle"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="showCopyDocumentPsb && checkUser && hasCandidate"
          @click="copyDocumentPsb"
          color="info"
          :icon="mdiDownloadCircle"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="showPrintDppSpp && checkUser"
          @click="printDppSpp"
          :label="'DPP & SPP'"
          color="info"
          :icon="mdiDownloadCircle"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="showPrintDppSpp && checkUser"
          @click="printDppSpp"
          color="info"
          :icon="mdiDownloadCircle"
          class="add-btn md:hidden"
        />

        <div v-if="addMaster">
          <jb-button
            v-if="addShow && checkUser"
            @click="addClick"
            :label="t('menu.add')"
            color="info"
            :icon="mdiPlusCircleOutline"
            class="add-btn hidden md:flex"
          />
          <jb-button
            v-if="addShow && checkUser"
            @click="addClick"
            color="info"
            :icon="mdiPlusCircleOutline"
            class="add-btn md:hidden"
          />
        </div>
        <div v-else>
          <jb-button
            v-if="addShow"
            @click="addClick"
            :label="t('menu.add')"
            color="info"
            :icon="mdiPlusCircleOutline"
            class="add-btn hidden md:flex"
          />
          <jb-button
            v-if="addShow"
            @click="addClick"
            color="info"
            :icon="mdiPlusCircleOutline"
            class="add-btn md:hidden"
          />
        </div>

        <jb-button
          v-if="saveShow"
          @click="saveClick"
          :label="t('menu.save')"
          color="info"
          :icon="mdiCheckCircleOutline"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="saveShow"
          @click="saveClick"
          color="info"
          :icon="mdiCheckCircleOutline"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="subShow"
          @click="subClick"
          :label="t('menu.blank') + 'Substitution'"
          color="info"
          :icon="mdiAccountSwitch"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="subShow"
          @click="subClick"
          color="info"
          :icon="mdiAccountSwitch"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="showHistoryUpload"
          @click="showHistory()"
          :label="'History'"
          color="info"
          :icon="mdiHistory"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="showHistoryUpload"
          @click="showHistory()"
          color="info"
          :icon="mdiHistory"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="showCsv"
          @click="downloadCsv()"
          :label="'Export'"
          color="success"
          :icon="mdiFileExcel"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="showCsv"
          @click="downloadCsv()"
          color="success"
          :icon="mdiFileExcel"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="showExcel"
          @click="ExcelData()"
          :label="'Export'"
          color="success"
          :icon="mdiFileExcel"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="showExcel"
          @click="ExcelData()"
          color="success"
          :icon="mdiFileExcel"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="showPdf"
          @click="PDFData()"
          :label="'PDF'"
          color="success"
          :icon="mdiFilePdfBox"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="showPdf"
          @click="PDFData()"
          color="success"
          :icon="mdiFilePdfBox"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="showTransfer"
          @click="transferClick()"
          color="info"
          :icon="mdiArrowRightBoldOutline"
          class="add-btn"
        />

        <jb-button
          v-if="uploadShow"
          @click="addClick"
          :label="t('Upload')"
          color="info"
          :icon="mdiProgressUpload"
          class="add-btn hidden md:flex"
        />
        <jb-button
          v-if="uploadShow"
          @click="addClick"
          color="info"
          :icon="mdiProgressUpload"
          class="add-btn md:hidden"
        />

        <jb-button
          v-if="uploadPdfShow"
          @click="uploadFromPdf"
          :label="t('Upload From PDF')"
          color="info"
          :icon="mdiProgressUpload"
          class="add-btn hidden md:flex"
        />
      </div>
    </header>

    <div
      v-if="empty"
      class="text-center py-24 text-gray-500 dark:text-gray-400"
    >
      <p>Nothing's here…</p>
    </div>

    <div v-else :class="{ 'pt-4': !hasTable }">
      <slot />
    </div>
  </component>
</template>

<script>
/* eslint-disable */
import {
  mdiPlusCircleOutline,
  mdiFileDocumentRemoveOutline,
  mdiFileRefreshOutline,
  mdiAccountSwitch,
  mdiCheckCircleOutline,
  mdiArrowRightBoldOutline,
  mdiInvoiceSend,
  mdiContentCopy,
  mdiFileExcel,
  mdiProgressUpload,
  mdiFilePdfBox,
  mdiHistory,
  mdiDownloadCircle,
} from "@mdi/js";
import { onBeforeMount, ref } from "@vue/runtime-core";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import Icon from "@/components/Icon";
import JbButton from "@/components/JbButton";
import CheckRadioPicker from "@/components/CheckRadioPicker";
import CryptoJS from "crypto-js";

export default {
  name: "CardComponent",
  components: { Icon, JbButton, CheckRadioPicker },
  props: {
    title: String,
    icon: String,
    master: Boolean,
    selectinv: Boolean,
    invoicelist: Boolean,
    outstadinglist: Boolean,
    showSave: Boolean,
    candidateId: String,
    showCopyDocumentPsb: Boolean,
    showPrintDppSpp: Boolean,
    showAdd: Boolean,
    showHistoryUpload: { type: Boolean, default: false },
    showCsv: { type: Boolean, default: false },
    showExcel: { type: Boolean, default: false },
    showPdf: { type: Boolean, default: false },
    showTransfer: { type: Boolean, default: false },
    generatePaymentShow: Boolean,
    closePaymentShow: Boolean,
    generateVAShow: Boolean,
    approveShow: Boolean,
    sendapproveShow: Boolean,
    copyrejectShow: Boolean,
    copysyllabussShow: Boolean,
    showSub: Boolean,
    headerIcon: String,
    hasTable: Boolean,
    empty: Boolean,
    form: Boolean,
    showUpload: Boolean,
    uploadPdfShow: Boolean,
    rounded: { type: String, default: "" },
    labelSendApproveButton: { type: String, default: "" },
    releaseRole: { type: String, default: "" },
  },
  emits: [
    "header-icon-click",
    "submit",
    "add-click",
    "pdf-click",
    "inv-select",
    "approve-click",
    "reject-click",
    "sendapprove-click",
    "copyreject-click",
  ],
  setup(props, { emit }) {
    const { t } = useI18n();
    const store = useStore();
    const darkMode = computed(() => store.state.darkMode);
    const computedHeaderIcon = computed(
      () => props.headerIcon ?? mdiPlusCircleOutline
    );

    const ExcelData = (event) => {
      emit("excel-click", event);
    };
    const PDFData = (event) => {
      emit("pdf-click", event);
    };
    const copyDocumentPsb = (event) => {
      emit("copy-document-psb", event);
    };
    const printDppSpp = (event) => {
      emit("print-dpp-spp", event);
    };
    const addClick = (event) => {
      emit("add-click", event);
    };
    const pdfClick = (event) => {
      emit("pdf-click", event);
    };
    const saveClick = (event) => {
      emit("save-click", event);
    };
    const subClick = (event) => {
      emit("sub-click", event);
    };
    const showHistory = (event) => {
      emit("show-history", event);
    };
    const downloadCsv = (event) => {
      emit("download-csv", event);
    };
    const transferClick = (event) => {
      emit("transfer-check", event);
    };
    const sendApproveData = (event) => {
      emit("sendapprove-click", event);
    };
    const coptRejectData = (event) => {
      emit("copyreject-click", event);
    };
    const coptSyllabussData = (event) => {
      emit("copysyllabuss-click", event);
    };
    const approveAllData = (event) => {
      emit("approve-click", event);
    };
    const rejectAllData = (event) => {
      emit("reject-click", event);
    };
    const generatePaymentData = (event) => {
      emit("generate-payment", event);
    };
    const closePaymentData = (event) => {
      emit("close-payment", event);
    };
    const generateVAData = (event) => {
      emit("generate-va", event);
    };

    const headerIconClick = () => {
      emit("header-icon-click");
    };

    const uploadFromPdf = () => {
      emit("upload-from-pdf");
    };

    const customElementsForm = reactive({
      checkbox: ["lorem"],
      radio: "one",
      is_active: [1],
      file: null,
    });

    const filter = reactive({
      selectinv: false,
    });

    const hasCandidate = computed(() => {
      return !!props.candidateId;
    });

    const Listoutstading = computed(() => props.outstadinglist);
    const Listinvoice = computed(() => props.invoicelist);
    const addMaster = computed(() => props.master);
    const showCopyDocumentPsb = computed(() => props.showCopyDocumentPsb);
    const showPrintDppSpp = computed(() => props.showPrintDppSpp);
    const addShow = computed(() => props.showAdd);
    const pdfShow = computed(() => props.showPdf);
    const showApprove = computed(() => props.approveShow);
    const showSendApprove = computed(() => props.sendapproveShow);
    const showCopyReject = computed(() => props.copyrejectShow);
    const showCopySyllabuss = computed(() => props.copysyllabussShow);
    const saveShow = computed(() => props.showSave);
    const subShow = computed(() => props.showSub);
    const uploadShow = computed(() => props.showUpload);
    const uploadPdfShow = computed(() => props.uploadPdfShow);

    const generatePayment = computed(() => props.generatePaymentShow);
    const closePayment = computed(() => props.closePaymentShow);
    const generateVA = computed(() => props.generateVAShow);

    const invselect = (evt) => {
        emit("inv-select", [filter.selectinv]);
    };

    // const headerFooterBorder = 'border-gray-100 dark:border-gray-700'

    // const headerBorder = 'border-b'

    const submit = (e) => {
        emit("submit", e);
    };

    const userRole = localStorage.getItem("roles");
    const checkUser = ref(false);

    const userCheck = async () => {
      if (userRole !== null) {
        const decryptedMessage = CryptoJS.AES.decrypt(
          localStorage.getItem("role"),
          "amatra1609"
        ).toString(CryptoJS.enc.Utf8);
        const myArray = decryptedMessage.split(",");

        const additionalRoles = props.releaseRole
          ? props.releaseRole
              .split(",")
              .map((r) => r.trim())
              .filter((r) => r !== "")
          : [];

        for (let i = 0; i < myArray.length; i++) {
          if (
            myArray[i] === "ROLE_ADMIN" ||
            myArray[i] === "ROLE_ADMIN_HRD" ||
            myArray[i] === "ROLE_ADMIN_FINANCE" ||
            myArray[i] === "ROLE_ADMIN_ACADEMIC" ||
            additionalRoles.includes(myArray[i])
          ) {
            checkUser.value = true;
          }
        }
      }
    };
    onBeforeMount(() => {
      userCheck();
    });

    return {
      userRole,
      userCheck,
      checkUser,
      t,
      darkMode,
      Listinvoice,
      Listoutstading,
      addMaster,
      invselect,
      filter,
      customElementsForm,
      showCopyDocumentPsb,
      showPrintDppSpp,
      addShow,
      pdfShow,
      generatePayment,
      closePayment,
      generateVA,
      showApprove,
      showSendApprove,
      showCopyReject,
      showCopySyllabuss,
      saveShow,
      subShow,
      mdiPlusCircleOutline,
      mdiFileDocumentRemoveOutline,
      mdiFileRefreshOutline,
      mdiCheckCircleOutline,
      mdiArrowRightBoldOutline,
      mdiContentCopy,
      mdiFileExcel,
      mdiInvoiceSend,
      mdiFilePdfBox,
      mdiHistory,
      mdiDownloadCircle,
      // addBtn,
      computedHeaderIcon,
      headerIconClick,
      ExcelData,
      PDFData,
      pdfClick,
      copyDocumentPsb,
      printDppSpp,
      addClick,
      saveClick,
      subClick,
      showHistory,
      downloadCsv,
      transferClick,
      // headerFooterBorder,
      // headerBorder,
      generatePaymentData,
      closePaymentData,
      generateVAData,
      approveAllData,
      sendApproveData,
      coptRejectData,
      coptSyllabussData,
      rejectAllData,
      submit,
      mdiAccountSwitch,
      mdiProgressUpload,
      uploadShow,
      hasCandidate,
      uploadFromPdf,
      uploadPdfShow,
    };
  },
};
</script>
